import type { PaymentMode } from '@/models'
import { neon } from '@/services/neon'

export type { PaymentMode }

export async function fetchActivePaymentModes(): Promise<PaymentMode[]> {
  const { data, error } = await neon
    .from('payment_modes')
    .select('*')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: true })

  if (error) throw new Error(error.message)
  return (data as PaymentMode[]) || []
}

export async function fetchAllPaymentModes(): Promise<PaymentMode[]> {
  const { data, error } = await neon
    .from('payment_modes')
    .select('*')
    .order('type', { ascending: true })
    .order('sort_order', { ascending: true })

  if (error) throw new Error(error.message)
  return (data as PaymentMode[]) || []
}

export async function createPaymentMode(input: Partial<PaymentMode>): Promise<PaymentMode> {
  const { data, error } = await neon.from('payment_modes').insert(input).select().single()
  if (error) throw new Error(error.message)
  return data as PaymentMode
}

export async function updatePaymentMode(
  id: string,
  input: Partial<PaymentMode>,
): Promise<PaymentMode> {
  const { data, error } = await neon
    .from('payment_modes')
    .update(input)
    .eq('id', id)
    .select()
    .single()
  if (error) throw new Error(error.message)
  return data as PaymentMode
}

export async function deletePaymentMode(id: string): Promise<void> {
  const { error } = await neon.from('payment_modes').delete().eq('id', id)
  if (error) throw new Error(error.message)
}
